var _defs, _circle, _polyline, _line, _line2, _polyline2, _polyline3, _polyline4, _circle2, _path, _circle3, _path2, _path3, _path4, _path5, _path6, _circle4, _path7, _path8, _circle5, _circle6, _path9, _path10, _path11, _circle7, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 425.2 425.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#92a5ae;}.cls-2{fill:none;}.cls-2,.cls-6{stroke:#19457c;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-3,.cls-6{fill:#46bda1;}.cls-4{fill:#fff;}.cls-5{fill:#19457c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Merpaa-Icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 212.6,
    cy: 212.6,
    r: 184.25
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "138.37 122.79 99 122.79 65.4 51.2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 122.24,
    y1: 218.76,
    x2: 162.61,
    y2: 177.03
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.79,
    y1: 177.03,
    x2: 299.78,
    y2: 228.77
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "284.03 122.79 350.4 122.79 350.4 137.72"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "264.51 77.53 279.78 61.77 370.8 61.77"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "67.75 379.87 116.4 379.87 117.94 317.66"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 67.75,
    cy: 379.87,
    r: 16.98
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M338.09,257.26c-5.4-11.52-25.82-20.29-37.9-19.08a48,48,0,0,0-20.24,7,78.31,78.31,0,0,0-24.21,14.94c-2.57,2.31-2.14,7.54,1.16,9.05A78.81,78.81,0,0,0,282,276.33c10.57,1,20.86-1.41,31.4-1.26,6.95.09,15.62,3.57,21.72-1.43C340,269.69,340.62,262.67,338.09,257.26Zm-16.08,7c-2.45,1-9.58-.7-12.5-.58-4.62.19-9.2.87-13.81,1.2a70.31,70.31,0,0,1-18.35-1,23.56,23.56,0,0,1,7.65-8.34c1.31-.48,2.65-.94,4-1.35a5.43,5.43,0,0,0,3.27-2.54,30.42,30.42,0,0,1,9.91-2.19c5.89-.19,11.27,3.08,16.24,5.84C320.84,256.59,329.86,261.2,322,264.25Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 211.2,
    cy: 122.79,
    r: 72.83
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M177.73,177s-13.77-27.67-2-34.56,58.07-10.48,68.89-2.78S250.07,177,250.07,177,211,202.14,177.73,177Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M247.17,96.91c-2-12.37-12.2-28.49-24.62-32.92s-26.32.84-34.6,10.71c-5.21,6.2-16.35,25.94-7.69,33.19a7.09,7.09,0,0,0,8.24.73,5.34,5.34,0,0,0,1.65-.5,5.29,5.29,0,0,0,3.15-.87c4-2.57,16.11-10.33,22.76-18.38a40.78,40.78,0,0,0,24,15.12C244.67,105,247.89,101.29,247.17,96.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.47,92.77a57.71,57.71,0,0,0,3,17.68c3.66,10.79,11.77,22.93,29.71,25.13,33.46,4.11,33.71-36.91,33.71-36.91s-2.46-32.23-31.5-32S178.47,92.77,178.47,92.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.86,90.56l26.94,17.63Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.49,110.45s31.68-4.39,35.37-19.89"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.94,
    cy: 268.21,
    r: 49.45
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.8,297.27s-.28-30.28,11.3-30.78,24.13-7.62,33,0,11,22.85,9.59,30.78S112.68,316.74,89.8,297.27Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.93,242.46a22.92,22.92,0,0,0-7.16-8.9,5.82,5.82,0,0,0-5.45-5.07,15.7,15.7,0,0,0-6.16.84,12,12,0,0,0-5.7,1.55c-3.84,2.18-8,6.2-9,10.62a13.56,13.56,0,0,0,1.2,8.18,16.93,16.93,0,0,0,19.52,14.58C132.18,262.51,139,252.15,134.93,242.46Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 117.59,
    cy: 245.8,
    r: 16.49
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 299.78,
    cy: 299.79,
    r: 71.02
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.54,279.8a42.27,42.27,0,0,0,.67,7.53c3.07,17,16.33,29.84,32.23,29.84,18.17,0,32.9-16.73,32.9-37.37s-14.73-37.37-32.9-37.37S267.54,259.16,267.54,279.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256.72,348.07s-3.08-29.73,16.24-30.9,56.1,0,56.1,0,11.84,0,13.3,16.24l1.46,16.24S301.75,384.14,256.72,348.07Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.79,271.69s81.73,14.55,80.34-8.37S282,224.74,259.79,271.69Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 350.4,
    cy: 161.75,
    r: 24.03
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 58.57,
    cy: 40.39,
    r: 12.79
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 383.59,
    cy: 61.77,
    r: 12.79
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/request_icon.14657620adc48296884a65ed6c4b5b82.svg";
export { ForwardRef as ReactComponent };